import cn from "classnames";
import { Text } from "../../../text";
import { HintProps } from "./types";
import styles from "./styles.module.scss";

export const Hint = ({ className, error, dataTestId, children }: HintProps) => (
  <Text
    size="xsmall"
    dataTestId={dataTestId}
    className={cn(styles.hint, { [styles.error]: error }, className)}
  >
    {children}
  </Text>
);
